import { buildTranslate } from 'locales'

const t = buildTranslate('recovery_ai.brand_voice')

// The canonical Thanx default paragraph, sourced from the locale so there is
// exactly one copy — a drift would silently turn an unedited default into
// "custom text" on save, flipping three merchant-visible mode labels.
//
// Resolved lazily rather than as a module-level const: buildTranslate reads the
// react-redux-i18n store, which is empty at import time. Every caller hits this
// at render / hydrate time, by when translations are loaded.
export const getDefaultBrandVoiceText = (): string => t('default_text')

// True when the buffer is the untouched Thanx default (whitespace-insensitive).
// Drives the "You're using Thanx default voice" hint and the save-collapse.
export const isDefaultBrandVoiceText = (text: string): boolean =>
  text.trim() === getDefaultBrandVoiceText().trim()

// Persist '' for an unedited default so the backend keeps DERIVING
// brand_voice_mode = 'default' (nexus configuration_entity.rb) and no no-op
// canned-response regen fires. Only collapse when the SEED was blank: a merchant
// whose config already stores the default paragraph verbatim must not open the
// modal already dirty.
export const collapseBrandVoiceText = (
  buffer: string,
  seedWasBlank: boolean
): string => (seedWasBlank && isDefaultBrandVoiceText(buffer) ? '' : buffer)

// Oxford-comma join for the "Analyzing …" copy, assembled from i18n list-join
// keys so no comma / "and" literal lands in a .tsx. Single-file v1 normally
// passes one name, so the multi-name branches exist mainly for their own test.
export const joinBrandVoiceFilenames = (names: string[]): string => {
  if (names.length === 0) return ''
  if (names.length === 1) return names[0]
  if (names.length === 2) {
    return t('list_join_two', { a: names[0], b: names[1] })
  }
  const head = names
    .slice(0, -1)
    .reduce((acc, next) => t('list_join_pair', { head: acc, next }))
  return t('list_join_last', { head, last: names[names.length - 1] })
}
